import numeral from 'numeral'
import { sortBy, isNumber } from 'lodash'
import { PROMOTION_ACTIONS, PROMOTION_ACTIONS_TYPES, PROMOTION_SCOPE } from '~/settings'

export function calculatePromotionPrice (price, promotion, quantity) {
  let promotionAction = promotion.promotion_actions?.[0] || {}

  if (promotion.promo_action_type === PROMOTION_ACTIONS_TYPES.STACKED) {
    const matchedPromo =
      sortBy(promotion.promotion_actions, 'min_qty')
      .findLast(i => i.min_qty <= quantity)

    if (!matchedPromo) return price

    promotionAction = matchedPromo
  }

  let discountPrice = 0

  if (promotionAction.type === PROMOTION_ACTIONS.FIX_RATE_ADJUSTMENT)
    discountPrice = (price > promotionAction.discount_value) ? numeral(price).subtract(promotionAction.discount_value).value() : 0

  if (promotionAction.type === PROMOTION_ACTIONS.PERCENTAGE_ADJUSTMENT)
    discountPrice = numeral(price).multiply(numeral(1).subtract(promotionAction.discount_value).value()).value()

  return discountPrice
}

export function calculateItemPrice (item, quantity, max, min) {
  const promotion = item.promotions?.[0] || item.promotion

  if (!promotion)
    return numeral(item.case_price_cents).multiply(quantity || 0).value()

  const isSkuScope = promotion.promo_scope === PROMOTION_SCOPE.VARIANT
  const totalOriginalPrice = numeral(item.case_price_cents).multiply(quantity).value()
  const promotionPrice = calculatePromotionPrice(item.case_price_cents, promotion, quantity)
  let caseLimit = isNumber(max) ? max : promotion.case_limit
  let minimum = isNumber(min) ? min : promotion.minimum_num_case

  if (isSkuScope) {
    caseLimit = promotion.case_limit
    minimum = promotion.minimum_num_case

    if (isNumber(minimum) && quantity < minimum) return totalOriginalPrice
  }

  if (!isSkuScope) {
    if (isNumber(minimum) && minimum > 0) return totalOriginalPrice
    if (isNumber(caseLimit) && caseLimit <= 0) return totalOriginalPrice
  }

  if (!caseLimit || quantity <= caseLimit)
    return numeral(promotionPrice).multiply(quantity).value()

  if (quantity > caseLimit) {
    const discountPrice = numeral(caseLimit).multiply(promotionPrice)
    const nonDiscountPrice = numeral(item.case_price_cents).multiply(quantity - caseLimit).value()

    return numeral(discountPrice).add(nonDiscountPrice).value()
  }
}
